import React from 'react'

const Menu = ({ color = '#DC7B19', size = '5' }) => {
  return (
    <svg
      className={`h-${size} w-${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.925 21.2254L16.125 10.1504H18.05L22.25 21.2254H20.325L19.35 18.4004H14.875L13.875 21.2254H11.925ZM15.425 16.8004H18.75L17.125 12.2254H17.05L15.425 16.8004ZM4.625 18.4504L3.325 17.1504L8 12.5004C7.41667 11.8504 6.90833 11.1794 6.475 10.4874C6.04167 9.79606 5.65833 9.06706 5.325 8.30039H7.25C7.53333 8.86706 7.83333 9.37106 8.15 9.81239C8.46667 10.2544 8.84167 10.7171 9.275 11.2004C9.95833 10.4671 10.525 9.71306 10.975 8.93839C11.425 8.16306 11.8 7.33372 12.1 6.45039H1.875V4.62539H8.325V2.77539H10.175V4.62539H16.625V6.45039H13.95C13.6167 7.55039 13.175 8.61272 12.625 9.63739C12.075 10.6627 11.3917 11.6337 10.575 12.5504L12.8 14.8004L12.1 16.7004L9.25 13.8504L4.625 18.4504Z"
        fill={color}
      />
    </svg>
  )
}

export default Menu
